import { SOCIAL_LINKS } from './contact';

export type GroomingTikTokVideo = {
    id: string;
    url: string;
    title: string;
    description: string;
};

export const GROOMING_TIKTOK_VIDEOS: readonly GroomingTikTokVideo[] = [
    {
        id: 'nail-trimming',
        url: 'https://www.tiktok.com/t/ZTBfNLnQn/',
        title: 'Nail trimming at home',
        description: 'Clippers, Dremel, and how we work around the quick.',
    },
    {
        id: 'recommended-products',
        url: 'https://www.tiktok.com/t/ZTBfNXJfn/',
        title: 'Recommended grooming products',
        description: 'Shampoos, tools, and products we reach for by coat type.',
    },
    {
        id: 'clipper-length',
        url: 'https://www.tiktok.com/t/ZTBfNbJhp/',
        title: 'Clipper length & poodle grooming',
        description: 'How we choose clipper length and groom a poodle at home.',
    },
] as const;

export const groomingTikTokVideoJsonLd = GROOMING_TIKTOK_VIDEOS.map((video, index) => ({
    '@type': 'ListItem',
    position: index + 1,
    item: {
        '@type': 'VideoObject',
        name: video.title,
        description: video.description,
        url: video.url,
        contentUrl: video.url,
        publisher: {
            '@type': 'Organization',
            name: 'Galia Standard Poodles',
            sameAs: SOCIAL_LINKS.tiktok,
        },
    },
}));
